import { EmploymentStatus, MedicalCondition, OptionItem, VehicleOwnerType } from 'types'

export const TITLES: string[] = ['Mr', 'Mrs', 'Miss', 'Ms', 'Mx', 'Dr']

const channels: string[] = [
  'Facebook',
  'Instagram',
  'TikTok',
  'Google search',
  'From a friend',
  'Comparison sites',
  'News',
  'Blog or online articles',
  'Other',
  "Don't know",
]

export const titleList: OptionItem[] = TITLES.map((channel) => ({
  label: channel,
  value: channel,
}))

export const trafficChannels: OptionItem<string>[] = channels.map((channel) => ({
  label: channel,
  value: channel,
}))

export const relationToDriver: OptionItem<VehicleOwnerType>[] = [
  {
    label: 'Spouse',
    value: VehicleOwnerType.SPOUSE,
  },
  {
    label: 'Parent',
    value: VehicleOwnerType.PARENT,
  },
  {
    label: 'Child',
    value: VehicleOwnerType.CHILD,
  },
  {
    label: 'Sibling',
    value: VehicleOwnerType.SIBLING,
  },
  {
    label: 'Other family',
    value: VehicleOwnerType.OTHER_FAMILY,
  },
  {
    label: 'Cohabiting partner',
    value: VehicleOwnerType.COHABITING_PARTNER,
  },
  {
    label: 'Other',
    value: VehicleOwnerType.OTHER,
  },
]

export const employmentStatusOptions: OptionItem<EmploymentStatus>[] = [
  { label: "Yes, I'm employed", value: EmploymentStatus.EMPLOYED },
  { label: "Yes, I'm self-employed", value: EmploymentStatus.SELF_EMPLOYED },
  { label: "No, I'm currently unemployed", value: EmploymentStatus.UNEMPLOYED },
  { label: "No, I'm retired", value: EmploymentStatus.RETIRED },
  { label: "No, I'm a stay-at-home person", value: EmploymentStatus.HOUSEPERSON },
  { label: "No, I'm unemployed due to a disability", value: EmploymentStatus.DISABILITY },
]

export const ADEmploymentStatusOptions: OptionItem<EmploymentStatus>[] = [
  { label: "Yes, they're employed", value: EmploymentStatus.EMPLOYED },
  { label: "Yes, they're self-employed", value: EmploymentStatus.SELF_EMPLOYED },
  { label: "No, they're currently unemployed", value: EmploymentStatus.UNEMPLOYED },
  { label: "No, they're retired", value: EmploymentStatus.RETIRED },
  { label: "No, they're a stay-at-home person", value: EmploymentStatus.HOUSEPERSON },
  { label: "No, they're a student", value: EmploymentStatus.EDUCATION },
  { label: "No, they're unemployed due to a disability", value: EmploymentStatus.DISABILITY },
]

export const medicalConditionOptions: OptionItem<MedicalCondition>[] = [
  {
    label: 'DVLA are aware - no restrictions',
    value: MedicalCondition.DVLA_AWARE_NO_RESTRICTIONS,
  },
  {
    label: 'DVLA are aware - 1 year restricted licence',
    value: MedicalCondition.DVLA_AWARE_1_YEAR_RESTRICTION,
  },
  {
    label: 'DVLA are aware - 2 year restricted licence',
    value: MedicalCondition.DVLA_AWARE_2_YEAR_RESTRICTION,
  },
  {
    label: 'DVLA are aware - 3 year restricted licence',
    value: MedicalCondition.DVLA_AWARE_3_YEAR_RESTRICTION,
  },
  {
    label: 'DVLA are aware - 5 year restricted licence',
    value: MedicalCondition.DVLA_AWARE_5_YEAR_RESTRICTION,
  },
  {
    label: 'Doctor has advised not to drive',
    value: MedicalCondition.ADVISED_NO_DRIVE,
  },
  { label: 'DVLA are not aware', value: MedicalCondition.DVLA_UNAWARE },
]
